import React from 'react';
import '../styles/github.css';

function TermsOfService() {
  const [theme, setTheme] = React.useState('dark');

  React.useEffect(() => {
    const savedTheme = localStorage.getItem('memo_theme') || 'dark';
    setTheme(savedTheme);
    document.body.classList.add(savedTheme + '-theme');
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('memo_theme', newTheme);
    document.body.classList.remove(theme + '-theme');
    document.body.classList.add(newTheme + '-theme');
  };

  return (
    <div style={styles.pageContainer}>
      {/* 主题切换按钮 */}
      <div className="theme-toggle" onClick={toggleTheme} style={styles.themeToggle}>
        {theme === 'dark' ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#f5f0e6">
            <path d="M9.37 5.51c-.18.64-.27 1.31-.27 1.99 0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27C17.45 17.19 14.93 19 12 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49zM12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#f9c796a4">
            <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06z"/>
          </svg>
        )}
      </div>

      <div style={styles.container}>
        <div className="card" style={styles.card}>
          <div style={styles.header}>
            <h1 style={styles.title}>MemoHub 服务条款</h1>
            <p style={styles.subtitle}>最后更新日期：{new Date().toLocaleDateString('zh-CN')}</p>
          </div>

          <div style={styles.content}>
            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>1. 接受条款</h2>
              <p style={styles.paragraph}>
                通过访问或使用 MemoHub 服务，您确认您已阅读、理解并同意受本服务条款的约束，成功注册账号认定为同意受本服务条款。如果您不同意这些条款，请不要使用我们的服务。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>2. 服务描述</h2>
              <p style={styles.paragraph}>
                MemoHub 是一个云端备忘录应用，允许用户创建、编辑、分类和管理备忘录。我们提供以下功能：
              </p>
              <ul style={styles.list}>
                <li>文本备忘录的创建和编辑</li>
                <li>手写备忘录功能</li>
                <li>备忘录分类管理</li>
                <li>跨设备同步</li>
                <li>主题切换功能</li>
              </ul>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>3. 用户账户</h2>
              <p style={styles.paragraph}>
                3.1 要使用 MemoHub，您需要创建一个账户。您同意提供准确、完整和最新的注册信息。
              </p>
              <p style={styles.paragraph}>
                3.2 您有责任保护您的账户密码和登录信息。您对您账户下发生的所有活动负责。
              </p>
              <p style={styles.paragraph}>
                3.3 您必须年满13岁才能使用 MemoHub。如果您未满18岁，您需要在父母或监护人的同意下使用我们的服务。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>4. 用户内容</h2>
              <p style={styles.paragraph}>
                4.1 您保留您创建、上传、提交或存储在 MemoHub 中的所有内容的权利。
              </p>
              <p style={styles.paragraph}>
                4.2 您声明并保证您拥有您提交内容的所有必要权利，并且您的内容不侵犯任何第三方的权利。
              </p>
              <p style={styles.paragraph}>
                4.3 您同意不通过我们的服务发布非法、有害、威胁性、骚扰性、诽谤性、淫秽、仇恨或其他令人反感的内容。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>5. 服务使用限制</h2>
              <p style={styles.paragraph}>
                您同意不：
              </p>
              <ul style={styles.list}>
                <li>尝试未经授权访问 MemoHub 的系统或网络</li>
                <li>干扰或破坏服务的正常运行</li>
                <li>使用自动化手段大量创建账户</li>
                <li>将服务用于任何非法目的</li>
                <li>上传病毒、恶意软件或其他有害代码</li>
              </ul>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>6. 隐私保护</h2>
              <p style={styles.paragraph}>
                我们非常重视您的隐私。我们的隐私政策解释了我们会如何收集、使用和保护您的个人信息。请仔细阅读我们的隐私政策。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>7. 服务变更和中止</h2>
              <p style={styles.paragraph}>
                7.1 我们保留随时修改、暂停或中止服务的权利，无需事先通知。
              </p>
              <p style={styles.paragraph}>
                7.2 如果发生不可抗力事件（如自然灾害、战争、政府行为等），导致服务无法继续提供，我们不承担相应责任。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>8. 免责声明</h2>
              <p style={styles.paragraph}>
                服务按"原样"提供，不提供任何明示或暗示的保证。我们不保证服务不会中断或没有错误。您使用服务的风险由您自行承担。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>9. 责任限制</h2>
              <p style={styles.paragraph}>
                在法律允许的最大范围内，MemoHub 及其关联方不对因使用或无法使用服务而产生的任何间接、附带、特殊或后果性损害负责。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>10. 条款修改</h2>
              <p style={styles.paragraph}>
                我们保留随时修改本条款的权利。如果进行重大修改，我们会通过网站公告或电子邮件通知您。继续使用服务表示您接受修改后的条款。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>11. 联系方式</h2>
              <p style={styles.paragraph}>
                如果您对本服务条款有任何疑问，请通过以下方式联系我们：
              </p>
              <p style={styles.contact}>
                邮箱：166217228@qq.com
              </p>
            </section>

            <div style={styles.footer}>
              <button 
                onClick={() => window.history.back()}
                className="btn btn-primary"
                style={styles.backButton}
              >
                返回
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: 'var(--color-bg-secondary)',
    padding: '20px',
  },
  themeToggle: {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 100,
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  container: {
    maxWidth: '900px',
    margin: '60px auto 40px',
  },
  card: {
    padding: '40px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    borderBottom: '2px solid var(--color-border-primary)',
    paddingBottom: '20px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: 'var(--color-text-primary)',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '14px',
    color: 'var(--color-text-tertiary)',
  },
  content: {
    fontSize: '15px',
    lineHeight: '1.7',
  },
  section: {
    marginBottom: '30px',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: 'var(--color-text-primary)',
    marginBottom: '15px',
    paddingBottom: '8px',
    borderBottom: '1px solid var(--color-border-primary)',
  },
  paragraph: {
    marginBottom: '15px',
    color: 'var(--color-text-secondary)',
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px',
    color: 'var(--color-text-secondary)',
  },
  contact: {
    backgroundColor: 'var(--color-bg-secondary)',
    padding: '15px',
    borderRadius: '8px',
    border: '1px solid var(--color-border-primary)',
    marginTop: '10px',
  },
  footer: {
    marginTop: '40px',
    textAlign: 'center',
    paddingTop: '20px',
    borderTop: '1px solid var(--color-border-primary)',
  },
  backButton: {
    padding: '12px 30px',
    fontSize: '16px',
  },
};

export default TermsOfService;